import { TabProfile } from 'components/user/user-detail/tab-profile/TabProfile'
import { useState } from 'react'

export const TabProfileContainer = ({ isLoading }) => {
    const [modal, setModal] = useState({
        profile: false,
        accessibility: false,
        change_password: false,
    })

    const props = {
        modal,
        setModal,
        isLoading,
    }

    return <TabProfile {...props} />
}
